import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import FiltersSidebar from "../components/FiltersSidebar";

const apiUrl = process.env.REACT_APP_API_URL;

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q");

  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({});
  const [categoryId, setCategoryId] = useState(null);

  // SEARCH
  useEffect(() => {
    if (!q) return;

    axios
      .get(`${apiUrl}/api/search`, {
        params: { q, ...selectedFilters },
      })
      .then((res) => {
        setItems(res.data);

        const categories = [
          ...new Set(res.data.map((i) => i.category_id)),
        ];

        setCategoryId(categories.length === 1 ? categories[0] : null);
      });
  }, [q, selectedFilters]);

  // LOAD FILTERS
  useEffect(() => {
    if (!categoryId) return;

    axios
      .get(`${apiUrl}/api/filters/${categoryId}`)
      .then((res) => setFilters(res.data));
  }, [categoryId]);

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header />

      <div className="max-w-7xl mx-auto px-6 py-8">
        <h1 className="text-2xl font-bold mb-6">
          Search results for "{q}"
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {categoryId && (
            <FiltersSidebar
              filters={filters}
              selected={selectedFilters}
              onChange={(k, v) =>
                setSelectedFilters((s) => ({ ...s, [k]: v }))
              }
            />
          )}

          <div className={categoryId ? "md:col-span-3" : "md:col-span-4"}>
            <div className="columns-2 md:columns-3 lg:columns-4 gap-6 space-y-6">
              {items.map((p) => (
                <Link
                  key={p.id}
                  to={`/detail/${p.id}`}
                  className="break-inside-avoid block"
                >
                  <div className="bg-white rounded-2xl shadow overflow-hidden">
                    <img src={p.image} className="w-full object-contain" />
                    <div className="p-3">
                      <p className="font-medium">{p.title}</p>
                      <p className="text-green-600 font-semibold">
                        {p.price} ETB
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
